import { Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import { ModalForm, type SubmitCallback } from 'components/UI/ModalForm';
import store from 'stores/RootStore';
import { normalizeInputSpace } from 'utils/String';

function NewFilterSetModal() {
  const store_creative = store.creative;
  const filterManager = store_creative?.ads.filter;
  const isVisible = filterManager?.showNewFilterModal;

  const handleOnClose = () => {
    filterManager?.closeNewFilterModal();
  };

  const canSubmit = filterManager && store_creative;
  const handleOnSubmit: SubmitCallback = async (values) => {
    if (canSubmit) {
      const filterName = String(values.filterName).trimEnd();
      filterManager.saveCurrentAs(filterName);
      await store_creative.save();
    }
  };

  return (
    <ModalForm
      formName="NewFilterSetModalForm"
      open={isVisible}
      onClose={handleOnClose}
      onSubmit={handleOnSubmit}
      okText="Create"
      title="New Filter"
    >
      <Form.Item
        label="Filter Name"
        name="filterName"
        initialValue={filterManager?.proposedFilterName}
        normalize={(v) => normalizeInputSpace(v)}
        rules={[{ required: true }]}
      >
        <Input disabled={!canSubmit} />
      </Form.Item>
    </ModalForm>
  );
}

export default observer(NewFilterSetModal);
